import { z } from "zod";
const CurrencySchema = z.enum(["TND", "EUR", "USD"]);
const MoneySchema = z.strictObject({
  amountMinor: z.string().regex(/^-?(0|[1-9]\d*)$/, "amountMinor must be an integer string without leading zeros").max(20),
  currency: CurrencySchema
});
export {
  CurrencySchema,
  MoneySchema
};
//# sourceMappingURL=money.js.map